import React from 'react';
import { Modal, Row } from 'react-bootstrap';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import './EditLoadProgressValidationModal.scss';
import { Col } from 'react-bootstrap';

interface EditLoadProgressValidationModalProps {
    show: boolean;
    onCancel: () => void;
    loadingErrorMessage: string;
    loadedErrorMessage: string;
    onSiteErrorMessage: string;
    deliveredErrorMessage: string;
    completedErrorMessage?: string;
    sandTicketImageErrorMessage?: string;
    bolTicketImageErrorMessage?: string;
    sandTicketNumberErrorMessage?: string;
    bolNumberErrorMessage?: string;
    weightErrorMessage?: string;
    milesToWellErrorMessage?: string;
    fromMarkLoad?: boolean;
    statusErrorMessage?: string;
    otherTicketNumberErrorMessage?: string;
    tmsIdErrorMessage?: string;
}

const EditLoadProgressValidationModal = ({
    show,
    onCancel,
    loadingErrorMessage,
    loadedErrorMessage,
    onSiteErrorMessage,
    deliveredErrorMessage,
    sandTicketImageErrorMessage,
    sandTicketNumberErrorMessage,
    bolNumberErrorMessage,
    bolTicketImageErrorMessage,
    weightErrorMessage,
    milesToWellErrorMessage,
    fromMarkLoad,
    statusErrorMessage,
    completedErrorMessage,
    otherTicketNumberErrorMessage,
    tmsIdErrorMessage,
}: EditLoadProgressValidationModalProps): React.ReactElement => {
    return (
        <Modal show={show} onHide={() => {}} centered className="EditLoadProgressValidationModal-Container">
            <Modal.Header className="EditLoadProgressValidationModal-Header">
                <i className="material-icons EditLoadProgressValidationModal-CloseIcon" onClick={onCancel}>
                    clear
                </i>
            </Modal.Header>
            <Modal.Body>
                <div className="EditLoadProgressValidationModal-HeaderText">
                    {statusErrorMessage ? 'Unsuccessful' : 'Missing fields'}
                </div>
                <div className="EditLoadProgressValidationModal-BodyText">
                    <Col className={fromMarkLoad === true ? 'EditLoadProgress-MarkLoadComplete' : ''}>
                        <Row>{loadingErrorMessage} </Row>
                        <Row>{loadedErrorMessage} </Row>
                        <Row>{onSiteErrorMessage} </Row>
                        <Row>{deliveredErrorMessage} </Row>
                        <Row>{completedErrorMessage} </Row>
                        <Row>{sandTicketNumberErrorMessage} </Row>
                        <Row>{bolNumberErrorMessage} </Row>
                        <Row>{otherTicketNumberErrorMessage} </Row>
                        <Row>{sandTicketImageErrorMessage} </Row>
                        <Row>{bolTicketImageErrorMessage} </Row>
                        <Row>{weightErrorMessage} </Row>
                        <Row>{milesToWellErrorMessage} </Row>
                        <Row>{tmsIdErrorMessage}</Row>
                        {statusErrorMessage && <Row>{statusErrorMessage} </Row>}
                    </Col>
                </div>
            </Modal.Body>
            <Modal.Footer className="EditLoadProgressValidationModal-Footer">
                <div className="EditLoadProgressValidationModal-ButtonContainer">
                    <CustomButton title={statusErrorMessage ? 'Refresh' : 'OK'} onClick={onCancel} isBordered />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default EditLoadProgressValidationModal;

